import * as React from 'react';
import './index.scss';
import Logo2 from '../logo2';
// import { Input, Modal, message, Radio } from 'antd';
// import { searchUser, login, requestCasualLogin, signin } from '../../model/api';
// import UserCard from '../userCard';
import { parse } from 'query-string';
import { checkToken } from '../../model/api';

// const { Search } = Input;

export default class Login extends React.Component {
  constructor(props) {
    super(props);
    // this.state = {
    //   text: "",
    //   users: [],
    //   empty: false,
    //   casualName: "",
    //   showContact: false,
    //   showCasual: false,
    //   showPwdInput: false,
    //   pwd: "",
    //   loginId: "",
    //   showSignIn: false,
    //   signinName: "",
    //   signinGender: "男"
    // }

    // this.handleInputChange = this.handleInputChange.bind(this);
    // this.handleSearch = this.handleSearch.bind(this);
    // this.handleLogin = this.handleLogin.bind(this);
    // this.handleContact = this.handleContact.bind(this);
    // this.handleOk = this.handleOk.bind(this);
    // this.handleCasualClick = this.handleCasualClick.bind(this);
    // this.handleCasualLogin = this.handleCasualLogin.bind(this);
    // this.handlePwdOK = this.handlePwdOK.bind(this);
    // this.handleSignInClick = this.handleSignInClick.bind(this);
    // this.handleSignIn = this.handleSignIn.bind(this);
  }

  gotoFeishuAuthPage() {
    const APP_ID = 'cli_a7e3adb8e079501c'
    const { redirect } = parse(window.location.search);
    // console.log("login path params=", parse(window.location.search), redirect)
    const path = redirect ? `/auth?redirect=${redirect}` : '/auth'
    const REDIRECT_URI = window.location.origin + path
    const STATE = '123'
    const scope = 'auth:user.id:read contact:contact.base:readonly contact:user.department_path:readonly'
    let feishuAuthPage = `https://open.feishu.cn/open-apis/authen/v1/index?app_id=${APP_ID}&redirect_uri=${REDIRECT_URI}&state=${STATE}&scope=${scope}` // feishuAuthUrl ;
    // console.log("feishuAuthPage=", feishuAuthPage)
    window.location.href = feishuAuthPage
  }

  async componentDidMount() {
    // console.log("login props=", this.props)
    const isValid = await checkToken()
    // 如果未登录跳到登录
    if (!isValid) {
      // this.gotoFeishuAuthPage()
    } else {
      this.props.history.push('/')
    }
  }

  // handleInputChange(e) {
  //   this.setState({text: e.target.value});
  // }

  // handleSearch(text) {
  //   if(text.length < 2) {
  //     message.warn("请输入相对完整的信息哦😊");
  //   }else {
  //     searchUser(text, this.props.ckey).then(data => {
  //       if(data.code == 0) {
  //         console.log("search user: ", data);
  //         if(data.data.length) {
  //           this.setState({users: data.data, empty: false});
  //         }else {
  //           this.setState({users: [], empty: true});
  //         }
  //       }
  //     })
  //   }
  // }

  // handleLogin(user) {
  //   if(user.is_encrypted) {
  //     this.setState({showPwdInput: true, pwd: "", loginId: user.id});
  //   }else {
  //     this.login(user.id);
  //   }
  // }

  // handlePwdOK() {
  //   if(this.state.pwd) {
  //     this.login(this.state.loginId, this.state.pwd);
  //     this.setState({showPwdInput: false, loginId: "", pwd: ""});
  //   }
  // }

  // login(id, password="") {
  //   login(id, password).then(data => {
  //     if(data.code == 0) {
  //       this.props.onLogin && this.props.onLogin(data.data);
  //     }else {
  //       message.error(data.msg);
  //     }
  //   })
  // }

  // handleContact() {
  //   this.setState({showContact: true});
  // }

  // handleOk() {
  //   this.setState({showContact: false});
  // }

  // handleCasualClick() {
  //   this.setState({showCasual: true});
  // }

  // handleCasualLogin() {
  //   if(this.state.casualName && this.state.casualName.length > 1) {
  //     requestCasualLogin({name: this.state.casualName, group: this.props.group}).then(data => {
  //       if(data.code == 0) {
  //         this.setState({showCasual: false});
  //         this.props.onLogin(data.data);
  //       }else {
  //         message.error("临时用户创建失败，请重新尝试。");
  //       }
  //     })
  //   }else {
  //     message.error("请输入完整姓名!");
  //   }
  // }

  // handleSignInClick() {
  //   this.setState({showSignIn: true});
  // }

  // handleSignIn() {
  //   if(this.state.signinName) {
  //     signin(this.state.signinName, this.state.signinGender, this.props.ckey).then(data => {
  //       if(data && data.code == 0) {
  //         this.handleLogin(data.data);
  //       }
  //     })
  //   }else {
  //     message.error("请填写有效用户名");
  //   }
  // }

  render() {
    return (
      <div className='login'>
        <div className='login-logo'>
          <Logo2 />
        </div>
        <div className='login-feishu' onClick={this.gotoFeishuAuthPage}>
          <img src={require('./images/feishu.png')} />
          <span>飞书登录</span>
        </div>
        {/* <img src=''  /> */}
        {/* <div className='login-logo'>
          <Logo2 />
        </div>
        <Search className='login-input' onChange={this.handleInputChange} value={this.state.text} placeholder={this.props.ckey == "1" ? '输入姓名或工号准备订餐！' : "请输入姓名查找用户"} onSearch={this.handleSearch} />
        <div className='login-user-list'>
        {
          !!this.state.users.length && this.state.users.map((user, i) => {
            return <UserCard data={user} key={i} tip="点击选择" onClick={() => this.handleLogin(user)} />
          })
        }
        {this.state.empty && !this.state.users.length && <div className="login-empty">找不到自己？别着急！
          <div><span className='login-contact' onClick={this.handleContact}>联系客服</span> 或 { this.props.ckey == "1" ? 
            <span className='login-contact' onClick={this.handleCasualClick}>临时订餐</span> : 
            <span className='login-contact' onClick={this.handleSignInClick}>注册用户</span>} 解决您的烦恼！</div>
        </div>}
        {!this.state.empty && !this.state.users.length && <div className='login-empty'>{this.props.ckey == "1" ? 
          <span className='login-contact' onClick={this.handleCasualClick}>临时订餐</span> :
          <span className='login-contact' onClick={this.handleSignInClick}>注册用户</span>}</div>}
        </div>
        <Modal
          title="联系客服 💁"
          visible={this.state.showContact}
          onOk={this.handleOk}
          onCancel={this.handleOk}
        >
          <div className="login-contact-avatar">
            <img src='https://avatarcdn.aminer.cn/upload/avatar/1362/1901/1464/53f3188cdabfae9a844267e7_0.jpg!160' />
          </div>
          <div className='login-contact-info'>王雅茗: <a href='tel:13466517728'>13521791636</a></div>
        </Modal>
        <Modal
          title="临时订餐"
          visible={this.state.showCasual}
          onOk={this.handleCasualLogin}
          onCancel={() => this.setState({showCasual: false})}
        >
          <Input placeholder='请输入姓名' onChange={e => this.setState({casualName: e.target.value})} value={this.state.casualName} onPressEnter={this.handleCasualLogin}/>
        </Modal>
        <Modal
          title="注册用户"
          visible={this.state.showSignIn}
          onOk={this.handleSignIn}
          onCancel={() => this.setState({showSignIn: false})}
        >
          <Input placeholder='请输入姓名' onChange={e => this.setState({signinName: e.target.value})} value={this.state.signinName} style={{marginBottom: "12px"}}/>
          <Radio.Group onChange={e => this.setState({signinGender: e.target.value})} value={this.state.signinGender}>
            <Radio value="男">男</Radio>
            <Radio value="女">女</Radio>
          </Radio.Group>
        </Modal>
        <Modal
          title="请输入密码"
          visible={this.state.showPwdInput}
          onOk={this.handlePwdOK}
          onCancel={() => this.setState({showPwdInput: false})}
        >
          <Input placeholder='密码' onChange={e => this.setState({pwd: e.target.value})} value={this.state.pwd} onPressEnter={this.handlePwdOK}/>
        </Modal> */}
      </div>
    )
  }
}